module.exports = __webpack_public_path__ + "static/img/two-dimensional.1991521.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/two-dimensional.jpg
// module id = 0ptQ
// module chunks = 1